import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";
// import VisaHomePreview from "./VisaHomePreview";

const homeMap = {
    1: 5,
    2: 6,
};

const MAX_CHARS = 4000;

const VisaHomeEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const languageId = Number(queryParams.get("lang")) || 1;
    const homeId = Number(id) || homeMap[languageId];

    const [loading, setLoading] = useState(true);
    const [showPreviewVisaHome, setShowPreviewVisaHome] = useState(false);
    const [previewData, setPreviewData] = useState(null);

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
        onOk: null,
    });


    const [lastValidContent, setLastValidContent] = useState("");

    const [formData, setFormData] = useState({
        visa_id: languageId,
        language_id: languageId,
        home_id: homeId,
        heading: "",
        description: "",
        card1: "",
        card2: "",
        status: "active",
        active: 1,
        updatedBy: 1,
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || "").length;
    };

    /* ================= FETCH DATA ================= */
    useEffect(() => {
        if (!languageId || !homeId) return;

        setLoading(true);

        API.post("visahome_list/condition", {
            language_id: languageId,
            home_id: homeId,
            visa_id: languageId,
        })
            .then((res) => {
                const data = res?.data?.data?.data?.[0];
                if (!data) return;

                setFormData({
                    visa_id: data.visa_id,
                    language_id: data.language_id,
                    home_id: data.home_id,
                    heading: data.heading || "",
                    description: data.description || "",
                    card1: data.card1 || "",
                    card2: data.card2 || "",
                    status: data.status || "active",
                    active: data.active ?? 1,
                    updatedBy: 1,
                });

                setLastValidContent(data.description || "");
            })
            .finally(() => setLoading(false));
    }, [languageId, homeId]);

    /* ================= HANDLERS ================= */
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEditorChange = (html, editor) => {
        const textLength = getPlainTextLength(html);

        if (textLength <= MAX_CHARS) {
            setLastValidContent(html);
            setFormData((prev) => ({ ...prev, description: html }));
        } else {
            editor.setData(lastValidContent);
        }
    };

    const handleUpdate = () => {
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required!",
                type: "info",
            });
        }

        if (!formData.card1.trim() || !formData.card2.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Both cards are required!",
                type: "info",
            });
        }

        setLoading(true);

        API.post("visahome_edit/update", formData)
            .then(() => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: "Home updated successfully!",
                    type: "success",
                    onOk: () => navigate("/homepage"),
                });
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Update failed!",
                    type: "error",
                    onOk: null,
                })
            )
            .finally(() => setLoading(false));

    };

    const handlePreview = () => {
        if (!formData.heading || !formData.description) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading and description are required for preview!",
                type: "info",
            });
        }

        setPreviewData({
            heading: formData.heading,
            description: formData.description,
            card1: formData.card1,
            card2: formData.card2,
        });

        setShowPreviewVisaHome(true);
    };

    /* ================= RENDER ================= */
    return (
        <div className="ourstory-containeradd">
            <div className="service-header-bar">
                <h2 className="services-title1">Edit Home</h2>

                <div className="button-group">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    navigate(
                                        `/VisaHomeEdit/${homeMap[newLang]}?lang=${newLang}`,
                                        { replace: true }
                                    );

                                }}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>

                    {/* <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button> */}
                    <button onClick={handleUpdate} className="language-save-btn">
                        Save
                    </button>
                    <button
                        className="language-save-btn"
                        onClick={() => navigate("/homepage")}
                    >
                        Back
                    </button>
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <div className="ourstoryedit-container">
                    <div className="form-group ourstory-full-width">
                        <label>
                            Heading <span className="required">*</span>
                        </label>
                        <textarea
                            className="textareahome"
                            type="text"
                            name="heading"
                            value={formData.heading}
                            onChange={handleChange}
                            rows={2}
                        />

                    </div>

                    <div className="news-form-group editor-small">
                        <label className="news-description-label">
                            <span className="label-text">Description <span className="required">*</span></span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="count" />
                                <span>
                                    {getPlainTextLength(formData.description)}/{MAX_CHARS}
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.description}
                            onChange={(e, editor) =>
                                handleEditorChange(editor.getData(), editor)
                            }
                        />
                    </div>

                    <div className="ourstory-right-section">
                        <div className="form-group">
                            <label>Card One <span className="required">*</span></label>
                            <input
                                type="text"
                                name="card1"
                                value={formData.card1}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>
                                Card Two <span className="required">*</span>
                            </label>
                            <textarea
                                className="textareahome"
                                type="text"
                                name="card2"
                                value={formData.card2}
                                onChange={handleChange}
                                rows={3}
                            />
                        </div>
                    </div>
                </div>
            )}

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => {
                                setPopup({ ...popup, show: false });
                                popup.onOk && popup.onOk();
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}


            {/* {showPreviewVisaHome && (
                <VisaHomePreview
                    previewService={previewData}
                    setShowPreviewVisaHome={setShowPreviewVisaHome}
                />
            )} */}
        </div>
    );
};

export default VisaHomeEdit;